// Reusable SEO metadata using React 19 native document metadata hoisting.
const SITE = "https://barrettcareerbrand.com.au";
const DEFAULT_IMG = `${SITE}/og-image.jpg`;

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMG,
  jsonLd,
}) {
  const canonical = `${SITE}${path}`;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </>
  );
}

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "Barrett Career Brand",
  url: SITE,
  image: DEFAULT_IMG,
  description:
    "Strategic professional positioning: aligning experience, skills, value and evidence with target roles across CV and LinkedIn — for experienced professionals, career changers, graduates and international jobseekers in Australia.",
  areaServed: "AU",
  priceRange: "$$",
  founder: {
    "@type": "Person",
    name: "George Barrett",
    jobTitle: "Career Brand Consultant",
  },
};

export const SITE_URL = SITE;
